import React, { useState, useRef, useEffect } from "react";
import { storyblokEditable, renderRichText, StoryblokComponent } from "gatsby-source-storyblok"
import TourItineraryCarousel from "./tourItineraryCarousel"
import HotelCarousel from "./hotelCarousel";
import * as styles from "./tourItem.module.css"
import * as richtextStyles from "./richtext.module.css"

const TourItineraryDetail = ({ itinerary }) => {

  const ItineraryDetailItem = ({blok, index, arrayLength}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [hotelModal, setHotelModal] = useState({ open: false, blok: null });
    const contentRef = useRef(null);

    const scrollToHotel = (sectionId) => {
      const element = document.getElementById(`${sectionId}`);
      if (element) {
        const yOffset = -90; // Adjust this value to match your navbar height
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
        window.history.pushState({}, '', `#${sectionId}`);
      }
    };

    const openHotelModal = () => {
      setHotelModal({ open: true, blok });
    };
    

    const toggleAccordion = () => {
      const content = contentRef.current;
      if (content.style.height) {
        content.style.height = null;
      } else {
        content.style.height = `${content.scrollHeight}px`;
      }
      setIsOpen(!isOpen);
    }
    // if param open is true toggleAccordion
    useEffect(() => {
      if (!blok.collapsed) {
        toggleAccordion();
      }
    }, []);

    if (!blok) return null;

    return(
      <div id={`itinerary-${blok.dayNumber}`} {...storyblokEditable(blok)}>

        {blok.dayNumber &&
        <div className="relative w-full h-[70px] mt-3 ml-2 md:ml-0">
          <img loading="lazy" src={`/icons/day${blok.dayNumber}.svg`} alt={`day-${blok.dayNumber}`}
            className="w-auto h-[70px]" />
        </div>
        }
        {!blok.dayNumber &&
        <div className="mx-auto relative w-full h-[32px] my-3">
          <img loading="lazy" src={`/icons/triangle-down.svg`} alt='down-arrow'
            className="w[32px] h-[32px] translate-x-[-8px]"/>
        </div>
        }
        <button
          onClick={toggleAccordion}
          className={`w-full text-left`}>
            <img className="inline-block w-8 h-8 mr-2 md:ml-1" loading="lazy" src={isOpen ? "/icons/minus.svg" : "/icons/plus.svg"} alt="Toggle" />
            { blok.dayTitle && <span className="font-serif font-bold text-2xl"> {blok.dayTitle} </span> }
            {!isOpen && !blok.dayTitle && blok.place?.length > 0 && <span className="font-serif font-bold text-xl"> {blok.place[0].placeName} </span> }
            {!isOpen && <span className="border border-gray-400 border-dotted p-1 rounded-md text-gray-500 text-sm">Expand to view Details</span> }
        </button>


        <div ref={contentRef} className="overflow-hidden transition-height duration-500 ease-in-out h-0 flex flex-wrap ml-3 md:ml-5 md:px-2 border-l border-dashed border-black"
          style={{backgroundImage: `linear-gradient(to right, white, white, ${blok.bgColor?.color})`}}>
          {!blok.hideCarousel &&
          <div className="w-full md:w-1/2">
            <TourItineraryCarousel blok={blok.carousel} />
            
            {blok.leftBlocks?.map((b) => (
              <StoryblokComponent blok={b} key={b._uid} />
            ))}
          </div>
          }

          <div className={`w-full ${blok.hideCarousel ? '' : 'md:w-1/2'}`}>

            <div className="p-4">

              { blok.place.map((place) => (
                <div key={place._uid}>
                  <h3 className="text-2xl font-serif font-bold">{place.placeName}</h3>
                  <div className={`pl-4 py-5 ${styles.itinerary_detail}`} dangerouslySetInnerHTML={{ __html: renderRichText(place.description) }} />
                </div>
              )) }

              <hr className="py-3"/>

              { blok.mealTitle && (
                <div className="meal">
                  <div className="flex">
                    <img src="/icons/meal.svg" className="w-[24px] h-[20px] mr-2" alt="Hotel icon"/>
                    {blok.mealTitle}
                  </div>
                  <div className={`pt-5`} dangerouslySetInnerHTML={{ __html: renderRichText(blok.mealDescription) }} />
                  <div className={`py-5 text-sm text-red-500 ${styles.hotel_notes}`} dangerouslySetInnerHTML={{ __html: renderRichText(blok.mealNotes) }} />
                </div>
              )}

              { blok.hotelName && (
                <div className="hotel">
                  <a className="flex cursor-pointer hover:drop-shadow-md underline underline-offset-4" onClick={openHotelModal}>
                    <img src="/icons/hotel.svg" className="w-[24px] h-[20px] mr-2" alt="Hotel icon"/>
                    {blok.hotelName}
                    <img src="/icons/arrow-black-right.svg" className="w-[18px] ml-2"/>
                  </a>
                  <div className={`py-5 text-sm text-red-500 ${styles.hotel_notes}`} dangerouslySetInnerHTML={{ __html: renderRichText(blok.hotelNotes) }} />
                </div>
              )}

              { blok.inGeneralNotes && 
                <div className="general-notes">
                  <div className="flex">
                    <div className={`py-5 ${richtextStyles.richText}`} dangerouslySetInnerHTML={{ __html: renderRichText(blok.inGeneralNotes) }} />
                  </div>
                </div>
              }
              
              {blok.rightBlocks?.map((b) => (
                <StoryblokComponent blok={b} key={b._uid} />
              ))}
            </div>
          </div>
        </div>

        {/* show the blok is the last item */}
        {index === arrayLength - 1 && (
          <div className="w-full h-[32px]">
            <span className="ml-[12px]">■</span>
          </div>
        )}

        {hotelModal.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 w-[100vw]" onClick={() => setHotelModal({ open: false, blok: null })}>
            <div className="bg-white p-6 rounded shadow-lg relative w-full max-w-lg" onClick={e => e.stopPropagation()}>
              <button className="absolute top-2 right-2 text-2xl" onClick={() => setHotelModal({ open: false, blok: null })}> &times;</button>
              <h2 className="text-xl font-bold mb-4">{hotelModal.blok.hotelName}</h2>
              <HotelCarousel blok={hotelModal.blok.hotelCarousel} />
              <div className="py-5 text-center">
                <h4 className=""><span className="px-2">{hotelModal.blok.hotelLocation}</span></h4>
                <h3 className="text-lg font-serif">{hotelModal.blok.hotelName}</h3>
              </div>
              <div dangerouslySetInnerHTML={{ __html: renderRichText(hotelModal.blok.hotelDescription) }} />
            </div>
          </div>
        )}
      </div>
    )
  }

  return(
    <div className="container max-w-screen-xl mx-auto py-10">
      {itinerary?.map((item, index) => 
        (<ItineraryDetailItem key={index} blok={item} index={index} arrayLength={itinerary.length} /> ))}
    </div>
  ) 
}

export default TourItineraryDetail
